/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Emptystate_Description3Inputs */

const en_settings_reportingapikeys_emptystate_description3 = /** @type {(inputs: Settings_Reportingapikeys_Emptystate_Description3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No API keys yet. Generate a key for an user to give them programmatic access to the reporting APIs.`)
};

/**
* | output |
* | --- |
* | "No API keys yet. Generate a key for an user to give them programmatic access to the reporting APIs." |
*
* @param {Settings_Reportingapikeys_Emptystate_Description3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_emptystate_description3 = /** @type {((inputs?: Settings_Reportingapikeys_Emptystate_Description3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Emptystate_Description3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_emptystate_description3(inputs)
});
export { settings_reportingapikeys_emptystate_description3 as "settings_reportingApiKeys_emptyState_description" }